import React from 'react';
import { Container } from 'react-bootstrap';
import IntegratedManagementWorkflows from './IntegratedManagementWorkflows';

const MyPolicyAcknowledgementsPage: React.FC = () => <Container className="py-4">
  <h1 className="h3">My policy acknowledgements</h1>
  <IntegratedManagementWorkflows personalOnly />
</Container>;
export default MyPolicyAcknowledgementsPage;
